import React, { useState } from 'react';
import { useEffect } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Card, Descriptions, Button, Modal, Input, message, Spin } from 'antd';

import sessionManager, { eVariableType } from '../../../SessionManager';
import api from '../../../api';
import stringres from '../../../translations/stringres';
import MenuAddEdit from '../../Common/MenuAddEdit';
import '../../Generic.css';
import '../EventiCliente/eventi.css';
import ContattiAddEdit from './ContattiAddEdit';

export default function Contatti(props) {
    const { codCliente } = props;

    const [opendlg, setOpendlg] = useState(false);
    const [contatti, setContatti] = useState(null);
    const [idContattoSel, setIdContattoSel] = useState(null);

    const [isLoading, setIsLoading] = useState(false);

    function Titolo(item) {
        return (
            <div className="containerunito">
                <p>{item.nomeComposto}</p>
            </div>
        );
    }

    useEffect(() => {
        loadData();
    }, []);

    function onClickAddEvento() {
        setIdContattoSel(null);
        setOpendlg(true);
    }

    function onClick(item) {
        setIdContattoSel(item.idContatto);
        setOpendlg(true);
    }

    function onCancel(e) {
        if (e) {
            loadData();
        }
        setOpendlg(false);
    }

    async function loadData() {
        try {
            setIsLoading(true);

            const result = await api.get(
                'CRM/Clienti/Contatti?idSocieta=' +
                    sessionManager.get(eVariableType.IDSocieta) +
                    '&codCliente=' +
                    codCliente
            );
            if (result != null && result.data != null) {
                setContatti(result.data);
            }
        } catch (error) {
            message.error(error.message);
        } finally {
            setIsLoading(false);
        }
    }

    async function onDelete(item) {
        try {
            const result = await api.delete(
                'CRM/Clienti/Contatti/Delete?idSocieta=' +
                    sessionManager.get(eVariableType.IDSocieta) +
                    '&idContatto=' +
                    item.idContatto
            );

            if (result != null && result.data != null) {
                message.success(stringres.t('successo'));
                loadData();
            } else {
                message.error(result.statusText);
            }

            message.success(stringres.t('successo'));
        } catch (error) {
            message.error(error.message);
        }
    }

    return (
        <div>
            <Spin spinning={isLoading}>
                <Card
                    title="Elenco contatti"
                    extra={
                        <Button onClick={onClickAddEvento}>
                            <PlusOutlined />
                        </Button>
                    }
                >
                    {contatti?.map((item) => (
                        <div key={item.idContatto}>
                            <Descriptions
                                key={item.idContatto}
                                size="small"
                                bordered
                                title={Titolo(item)}
                                layout="vertical"
                                style={{ marginTop: '0px', marginBottom: '0px' }}
                                extra={
                                    <div>
                                        <MenuAddEdit
                                            onModifica={() => onClick(item)}
                                            onCancella={() => onDelete(item)}
                                        ></MenuAddEdit>
                                    </div>
                                }
                            >
                                <Descriptions.Item label="Descrizione">
                                    <Input className="Input-InForm" defaultValue={item.descrizioneContatto}></Input>
                                </Descriptions.Item>
                                <Descriptions.Item label="Contatto">
                                    <Input className="Input-InForm" defaultValue={item.nomeComposto}></Input>
                                </Descriptions.Item>
                                <Descriptions.Item label="Email">
                                    <Input className="Input-InForm" defaultValue={item.email}></Input>
                                </Descriptions.Item>
                                <Descriptions.Item label="Telefono">
                                    <Input className="Input-InForm" defaultValue={item.telefono}></Input>
                                </Descriptions.Item>
                                <Descriptions.Item label="Telefono 2">
                                    <Input className="Input-InForm" defaultValue={item.cellulare}></Input>
                                </Descriptions.Item>
                            </Descriptions>
                        </div>
                    ))}
                </Card>
                <Modal
                    title={stringres.t('contatto')}
                    destroyOnClose="true"
                    open={opendlg}
                    onCancel={() => setOpendlg(false)}
                    footer={null}
                >
                    <ContattiAddEdit
                        codCliente={codCliente}
                        onCancel={onCancel}
                        idContatto={idContattoSel}
                    ></ContattiAddEdit>
                </Modal>
            </Spin>
        </div>
    );
}
